/* Warehouse Bold — PDP add-ons in the cart: cascade a removed parent */
(function () {
  'use strict';

  /* ⚠ ONE delegated sweep on document, behind a run-once flag. cart.js
     replaces the innerHTML of the cart containers on EVERY mutation, so
     anything bound inside them dies on the first quantity change. Same shape
     as assets/wb-kit-cart.js. */
  if (window.__wbAddonsCart) return;
  window.__wbAddonsCart = true;

  function routes() {
    return (window.FoxTheme && window.FoxTheme.routes) || {};
  }

  var busy = false;

  /* Remove children whose parent has gone.

     A sweep rather than a click handler on purpose: the parent can leave the
     cart by the remove link, by stepping its quantity to 0, or by a cart
     update from anywhere else in the theme. Reconciling after the fact
     catches all three, where intercepting one control catches one.

     A child is an orphan when no line in its _addon_group is a parent — a
     parent carries _addon_group and no _addon_of. Children keep their own
     quantities while the parent is present (1 kit, 3 cloths), so only the
     parent's ABSENCE cascades, never its quantity. */
  function sweep() {
    if (busy) return;
    busy = true;
    fetch((routes().cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var parents = Object.create(null);
        var i, it, p;
        for (i = 0; i < cart.items.length; i++) {
          it = cart.items[i];
          p = it.properties;
          if (p && p._addon_group && !p._addon_of) parents[p._addon_group] = true;
        }
        var updates = {};
        var found = 0;
        for (i = 0; i < cart.items.length; i++) {
          it = cart.items[i];
          p = it.properties;
          if (p && p._addon_of && p._addon_group && !parents[p._addon_group]) {
            updates[it.key] = 0;
            found++;
          }
        }
        if (!found) return null;

        var sections = [];
        document.dispatchEvent(new CustomEvent('cart:grouped-sections', { detail: { sections: sections } }));

        return fetch(routes().cart_update_url || '/cart/update', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({
            updates: updates,
            sections: sections.join(','),
            sections_url: window.location.pathname
          })
        }).then(function () {
          /* ⚠ Clear `busy` BEFORE asking for the refresh. The refresh fires
             cart:updated, which re-enters here; on that pass nothing is
             orphaned any more, so it finds zero and stops. Leaving the flag
             set would instead wedge the sweep for the rest of the session. */
          busy = false;
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });
      })
      .catch(function () { return null; })
      .then(function () { busy = false; });
  }

  /* Remove the whole group in ONE keyed update.

     ⚠ Measured 2026-09-11: removing a line on the CART PAGE fires only
     cart:grouped-sections — never cart:updated or cart:refresh — and does not
     navigate. So a listener-only design cascades in the drawer and silently
     does nothing on the cart page, which is exactly where a customer removes
     things. Intercepting the control is both faster and atomic: parent and
     children go in a single request, so there is never a frame showing
     orphaned add-ons. */
  function removeGroup(gid, el) {
    if (el) { el.setAttribute('aria-busy', 'true'); }
    return fetch((routes().cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        var found = 0;
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          if (it.properties && it.properties._addon_group === gid) { updates[it.key] = 0; found++; }
        }
        if (!found) return null;
        var sections = [];
        document.dispatchEvent(new CustomEvent('cart:grouped-sections', { detail: { sections: sections } }));
        return fetch(routes().cart_update_url || '/cart/update', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({
            updates: updates,
            sections: sections.join(','),
            sections_url: window.location.pathname
          })
        });
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (window.location.pathname.indexOf('/cart') === 0) window.location.reload();
      })
      .catch(function () {
        if (el) el.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('[is="cart-remove-item"]');
    if (!rm) return;
    var host = rm.closest('[data-wb-addon-group]');
    if (!host) return;
    e.preventDefault();
    e.stopPropagation();
    removeGroup(host.getAttribute('data-wb-addon-group'), rm);
  }, true);

  document.addEventListener('cart:updated', sweep);
  document.addEventListener('cart:refresh', sweep);

  /* Backstop for the paths the click handler cannot see — a parent stepped
     down to 0, or any other code path that empties a line. The sweep re-reads
     the cart, so running it a beat early simply finds nothing and stops. */
  var settle = null;
  document.addEventListener('cart:grouped-sections', function () {
    clearTimeout(settle);
    settle = setTimeout(sweep, 900);
  });

  /* ⚠ In-page mutations fire an event; a removal that NAVIGATES does not.
     The cart page's remove control reloads, so the next document opens with
     orphans already in the cart and nothing left to listen for. Liquid has
     already worked out whether that is the case (snippets/wb-addon-orphans),
     so this costs a /cart.js request only in the rare state that needs one,
     rather than one on every page of the site. */
  function bootSweep() {
    if (document.querySelector('[data-wb-addon-orphans]')) sweep();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootSweep);
  } else {
    bootSweep();
  }
})();
